const blogData = {
    types: ['blog', 'news']
}

export default blogData

